import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=a161d244&scoped=true"
import script from "./uploadPhoto.vue?vue&type=script&lang=js"
export * from "./uploadPhoto.vue?vue&type=script&lang=js"
import style0 from "./uploadPhoto.vue?vue&type=style&index=0&id=a161d244&prod&scoped=true&lang=scss"
import style1 from "./uploadPhoto.vue?vue&type=style&index=1&id=a161d244&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a161d244",
  null
  
)

export default component.exports